export const tools = [
  {
    number: '01',
    title: 'Craniofacial Growth Assessment Checklist',
    description:
      'A structured checklist covering key areas to review during growth-related clinical assessment.',
  },
  {
    number: '02',
    title: 'Skeletal Relationship Comparison Matrix',
    description:
      'A visual reference for organizing sagittal, vertical, and transverse skeletal findings.',
  },
  {
    number: '03',
    title: 'Growth Maturity Reference Charts',
    description:
      'Educational charts explaining common developmental indicators and their limitations.',
  },
  {
    number: '04',
    title: 'Orthopedic Planning Considerations Worksheet',
    description:
      'A printable framework for documenting diagnostic findings, treatment objectives, and factors requiring specialist evaluation.',
  },
  {
    number: '05',
    title: 'Clinical Growth Monitoring Template',
    description:
      'A structured form for recording observations and comparing developmental findings over time.',
  },
];
